//import 'waypoints/lib/jquery.waypoints.min';
$(document).ready(function () {
    'use strict';
    let experienceEditor = $('.is-experience-editor');

    if (!experienceEditor.length) {
        let gradientTrigger = $('.trigger-gradient.fixed-not-scrolled');

        if (!gradientTrigger.length) {
            $(window).on('scroll', function () {
                if ($(window).scrollTop() > 0) {
                    $('header').addClass('scrolled');
                } else {
                    $('header').removeClass('scrolled');
                }
            });
        }
    }

    $('nav .navbar-toggler-icon').click(function () {
        if ((($('nav .navbar-toggler').attr('aria-expanded')) === "false") && ($(window).width() < 768)) {
            $('body').addClass('body--no-scroll');
            $('nav div.navbar-collapse, nav .navbar-toggler-icon').addClass('animated-slideinleft');
            // $('nav').addClass('animated-slideinleft');
            $('nav div.navbar-collapse .nav__cherokee-mobile-menu').css('display', 'block');
            $('header .card').css('z-index', '-1');
            $('nav .book-a-room__btn-group').css('z-index', '0');

        } else {
            $('body').removeClass('body--no-scroll');
            $('nav div.navbar-collapse, nav .navbar-toggler-icon').removeClass('animated-slideinleft');
            //$('nav').removeClass('animated-slideinleft');
            $('nav div.navbar-collapse .nav__cherokee-mobile-menu').css('display', 'none');
            $('header .card').css('z-index', '1');
            $('nav .book-a-room__btn-group').css('z-index', '2');
        }

        if ($('header').hasClass('trigger-gradient') && ($(window).width() < 768)) {
            if ((($('header nav .navbar-toggler').attr('aria-expanded')) === "false") && ($(window).width() < 768)) {
                $('header.trigger-gradient.fixed-not-scrolled').css('position', 'absolute');
            }
            else {
                $('header').css('position', 'static');
            }
        }
    });

});


$(document).ready(function () {
    var htmlString = $('header .card .nav-list li.active a').html();
    $('header .card h5').text(htmlString);

    $('header .card .nav-list li').click(function () {
        $('header .card .nav-list li').removeClass("active");
        $(this).addClass("active");

        htmlString = $('header .card .nav-list li.active a').html();
        $('header .card h5').text(htmlString);
    });
});


// Make menu item active on click
// $(document).ready(function () {
//   $('.navbar-nav li a').click(function(){
//      $('.navbar-nav li a').parent().removeClass("active");
//      $(this).parent().addClass("active");
// });
// });